import { DistributionMethods } from 'backoffice/components/DropRequests/types/types'

const urlForDistributionMethods = {
  MINT_LINK: '',
  WEBSITE: process.env.REACT_APP_SUGGESTED_PASSCODE_WEBSITES,
  DELIVERY: '',
  SECRET: process.env.REACT_APP_SUGGESTED_PASSCODE_SECRETS,
}

export async function saveSuggestedPasscode(
  eventId: string,
  suggestedPasscode: string,
  ussedPasscode: string,
  selectedDistributionMethod: DistributionMethods,
) {
  const suggestedPasscodeForm: FormData = new FormData()
  suggestedPasscodeForm.append('DROP_ID', eventId)
  suggestedPasscodeForm.append('SUGGESTED_PASSCODE', suggestedPasscode)
  suggestedPasscodeForm.append('USED_PASSCODE', ussedPasscode)

  const postUrl = urlForDistributionMethods[selectedDistributionMethod]

  return fetch(`${postUrl}`, {
    method: 'POST',
    body: suggestedPasscodeForm,
  })
}
